//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MemberWorkOrderLogs from "./componets/member-workOrder-logs";
import {formatDate} from "../../../lib/date";
import util from "../../../lib/util";

export default {
    name: "member-workSheetDetail",
    components: {MemberWorkOrderLogs},
    data() {
        return {
            // workOrderInfo: {},
            isDelayEndStr: '',
            downloadUrl: util.ApiUrl + 'file/download/',
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        }
    },
    methods: {
        /*工单信息*/
        getWorkOrderById() {
            this.$toast.loading({
                duration: 0,
                message: ''
            });
            this.$store.dispatch({
                type: 'workOrder/getWorkOrderById',
                id: this.id
            }).then((res) => {
                // this.workOrderInfo = this.$store.state.workOrder.workOrderInfo;
                // this.init();
            }).finally(() => {
                this.$toast.clear();
            })
        },

        handleClick() {
            this.$router.push({name: 'user'})
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getWorkOrderById();
        }
    }
}
